import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import WelcomeToAutoRouting from '../../images/welcome-auto-routing.svg';
import messages from '../../messages';
import commonStyles from '../../../style.module.less';
import style from '../../style.module.less';

const StartStep = () => {
  const intl = useIntl();

  return (
    <div className={commonStyles['step-content']}>
      <Text className={style['step-title']} textType={TextType.H3} value={messages.welcomeToAutoRouting} />
      <Text className={style['step-paragraph']} textType={TextType.Paragraph} value={messages.whatDoesAutoRoutingDo} />
      <ul className={classnames(commonStyles['auto-routing-bulleted-list'], style['auto-routing-wizard-list'])}>
        <li className={commonStyles['auto-routing-bulleted-list-item']}>
          <Text textType={TextType.Paragraph} value={messages.descriptionOfWhatAutoRoutingDoes1} />
        </li>
        <li className={commonStyles['auto-routing-bulleted-list-item']}>
          <Text textType={TextType.Paragraph} value={messages.descriptionOfWhatAutoRoutingDoes2} />
        </li>
        <li className={commonStyles['auto-routing-bulleted-list-item']}>
          <Text textType={TextType.Paragraph} value={messages.descriptionOfWhatAutoRoutingDoes3} />
        </li>
      </ul>
      <div className={classnames(commonStyles['settings-page-section'], style['auto-routing-flex-grid'])}>
        <div className={classnames(commonStyles['flex-input'])}>
          <img
            alt={intl.formatMessage(messages.welcomeToAutoRouting)}
            className={style['auto-routing-wizard-img']}
            src={WelcomeToAutoRouting}
          />
        </div>
        <div className={classnames(commonStyles['flex-input'])}>
          <Text className={style['step-title']} textType={TextType.H3} value={messages.autoRoutingSetup} />
          <Text
            className={style['step-paragraph']}
            formattedMessageValues={{
              link: (chunks) => (
                <Button className={style['auto-routing-setup-link']} href='/settings/warehouses' theme='link'>
                  {chunks}
                </Button>
              ),
            }}
            textType={TextType.Paragraph}
            value={messages.autoRoutingSetupInstructions1}
          />
          <Text
            formattedMessageValues={{
              b: (chunks) => <span className={commonStyles.bolded}>{chunks}</span>,
            }}
            textType={TextType.Paragraph}
            value={messages.autoRoutingSetupInstructions2}
          />
        </div>
      </div>
    </div>
  );
};

export default StartStep;
